import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <img
                            src="/vision logo.jpeg"
                            alt="Vision Sports Logo"
                        />
                        <h3 className="text-2xl font-black uppercase text-white mb-2">Vision <span className="text-secondary">Sports</span></h3>
                        <p>Developing Zimbabwe's next generation of champions through excellence, discipline, and elite training.</p>
                    </div>

                    <div>
                        <h4>Quick Links</h4>
                        <ul className="footer-links">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/academy">Programs</Link></li>
                            <li><Link to="/shop">Sports Shop</Link></li>
                            <li><Link to="/community">Impact</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4>Contact</h4>
                        <ul className="footer-links">
                            <li className="flex items-center gap-2 mb-2">
                                <MapPin size={16} className="text-secondary" />
                                <span>Shop 57, Fife Avenue Mall, Harare</span>
                            </li>
                            <li className="flex items-center gap-2 mb-2">
                                <Phone size={16} className="text-secondary" />
                                <span><a href="https://wa.me/263781665264" target="_blank" rel="noopener noreferrer" className="hover:text-secondary">+263 781 665 264</a></span>
                            </li>
                            <li className="flex items-center gap-2 mb-2">
                                <Mail size={16} className="text-secondary" />
                                <span>info@visionsports.com</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-copyright">
                        <p>&copy; {new Date().getFullYear()} Vision Sports Academy. All Rights Reserved.</p>
                        <p className="text-xs opacity-50 mt-1">Designed by <a href="https://kodebuildtech.com/" target="_blank" rel="noopener noreferrer" className="hover:text-secondary">kodebuild</a></p>
                    </div>
                    <div className="footer-socials">
                        <Facebook size={20} className="hover:text-secondary cursor-pointer" />
                        <Instagram size={20} className="hover:text-secondary cursor-pointer" />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
